<div class="logs-container">
    <frg-cards class="logs-card" [title]="pageTitle">
        <div class="inside-card-wrapper">
            <div class="filters-wrapper">
                <form class="form-filtre" *ngIf="domainsListForm">
                    <frg-form-input
                      id="domain"
                      label="Domaine"
                      type="ngSelect"
                      [selectValue]="domainsList"
                      [formGroup]="domainsListForm"
                      [control]="domainsListForm.get('domain')"
                    ></frg-form-input>
                    <frg-form-input
                      id="result"
                      label="Résultat"
                      type="ngSelect"
                      [selectValue]="resultsList"
                      [formGroup]="domainsListForm"
                      [control]="domainsListForm.get('result')"
                    ></frg-form-input>
                    <frg-form-input
                      id="action"
                      label="Actions"
                      type="ngSelect"
                      [selectValue]="actionsList"
                      [formGroup]="domainsListForm"
                      [control]="domainsListForm.get('action')"
                      checkSelectValueLength="true"
                    ></frg-form-input>
                    <frg-form-input
                      id="dateStart"
                      label="Date de départ"
                      type="date"
                      [formGroup]="domainsListForm"
                      [control]="domainsListForm.get('dateStart')"
                    ></frg-form-input>
                    <frg-form-input
                      id="dateEnd"
                      label="Date de fin"
                      type="date"
                      [formGroup]="domainsListForm"
                      [control]="domainsListForm.get('dateEnd')"
                    ></frg-form-input>
                </form>
                <div class="export-btn-container" style="margin-top: 10px; display: flex; justify-content: flex-end;">
                  <frg-button (activated)="export()">Exporter en CSV</frg-button>
                </div>
            </div>

            <div class="logs-table-wrapper">
                <frg-table
                    [keysBody]="logsTable"
                    [keysColumn]="logsTableColumnTable"
                    (onChangePage)="onChangePage($event)"
                ></frg-table>
            </div>
        </div>
    </frg-cards>

    <frg-cards class="anomalies-card" *ngIf="displayRechercheAnomalies" title="Rechercher des anomalies dans les historiques d'identité">
      <frg-button (activated)="searchAnomalies()">Rechercher des anomalies</frg-button>
      <div>

        <table mat-table [dataSource]="listAnomalies" class="mat-elevation-z8">
          
          <ng-container matColumnDef="nomPrenom">
            <th mat-header-cell *matHeaderCellDef> Nom et Prénom du patient </th>
            <td mat-cell *matCellDef="let anomalie"> {{anomalie.nomPrenom}} </td>
          </ng-container>
          
          <ng-container matColumnDef="anomalies">
            <th mat-header-cell *matHeaderCellDef> Anomalies </th>
            <td mat-cell *matCellDef="let anomalie">
              <ng-container *ngFor="let raison of anomalie.raisons">
                <ng-container [ngSwitch]="raison">
                  <div class="reason" *ngSwitchCase="anomalieRaisonEnumTpl.TooManyFieldsUpdatedAtOnce">Trop de champs modifiés en même temps</div>
                  <div class="reason" *ngSwitchCase="anomalieRaisonEnumTpl.TooManyFieldsUpdatedSameDay">Trop de modifications en une journée</div>
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="navigateToPatient(row)" class="table-row"></tr>
  
        </table>
      </div>
  </frg-cards>
</div>
